import React, { ComponentProps, Suspense, useEffect, useState } from "react";

import type { NotificationDetailModal as NotificationDetailModalComponent } from "./NotificationDetailModal";

export type { MessageData } from "./NotificationDetailModal";

/**
 * The detail modal renders notification bodies as HTML, so it pulls in
 * rehype/parse5 and DOMPurify — around 275KB. Its three call sites all sit on
 * paths that render on every page (the sidebar, the connections table), so a
 * static import puts that HTML parser in the initial bundle for a dialog most
 * sessions never open. Every call site should use this instead.
 */
const NotificationDetailModal = React.lazy(() =>
  import("./NotificationDetailModal").then((m) => ({
    default: m.NotificationDetailModal,
  })),
);

export function NotificationDetailModalLazy(
  props: ComponentProps<typeof NotificationDetailModalComponent>,
) {
  // Nothing is fetched until the modal is first opened, and it stays mounted
  // from then on so the close transition still plays.
  const [hasOpened, setHasOpened] = useState(false);
  useEffect(() => {
    if (props.isOpen) setHasOpened(true);
  }, [props.isOpen]);

  if (!props.isOpen && !hasOpened) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <NotificationDetailModal {...props} />
    </Suspense>
  );
}
